(() => {
  function setup(scope) {
    scope.querySelectorAll('[data-myshie-collection]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const density = section.querySelector('.mc-density');
      if (density) density.hidden = false;
      section.querySelectorAll('[data-density]').forEach(button => button.addEventListener('click', () => {
        section.dataset.density = button.dataset.density;
        section.querySelectorAll('[data-density]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      }));
      const filter = section.querySelector('[data-filters]');
      if (filter) {
        const summary = filter.querySelector('summary');
        const panel = filter.querySelector('.mc-filters__panel');
        let previousOverflow = '';
        const close = () => { filter.open = false; summary.focus(); };
        filter.querySelector('[data-filter-close]').addEventListener('click', close);
        filter.querySelector('[data-filter-backdrop]').addEventListener('click', close);
        filter.addEventListener('toggle', () => {
          if (filter.open) { previousOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; panel.querySelector('button').focus(); }
          else document.body.style.overflow = previousOverflow;
        });
        panel.addEventListener('keydown', event => {
          if (event.key === 'Escape') { event.preventDefault(); close(); }
          if (event.key !== 'Tab') return;
          const focusable = [...panel.querySelectorAll('a[href],button,input,summary,select')].filter(el => !el.disabled && el.getClientRects().length);
          const first = focusable[0], last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        });
      }
      const status = section.querySelector('.mc-cart-status');
      const message = status.querySelector('[data-cart-status]');
      status.querySelector('[data-status-close]').addEventListener('click', () => { status.hidden = true; });
      section.querySelectorAll('.mc-quick__form').forEach(form => form.addEventListener('submit', async event => {
        if (!event.submitter || form.getAttribute('aria-busy') === 'true') { event.preventDefault(); return; }
        event.preventDefault();
        const data = new FormData(form);
        data.set('id', event.submitter.value);
        const buttons = [...form.querySelectorAll('button')];
        const original = buttons.map(button => button.disabled);
        form.setAttribute('aria-busy', 'true'); buttons.forEach(button => button.disabled = true);
        try {
          const endpoint = new URL(form.action);
          endpoint.pathname += '.js';
          const response = await fetch(endpoint, {method:'POST',body:data,headers:{Accept:'application/json'}});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || section.dataset.addError);
          message.textContent = section.dataset.added;
          status.hidden = false;
          form.closest('details').open = false;
          const root = window.Shopify?.routes?.root || '/';
          const cartResponse = await fetch(root + 'cart.js', {headers:{Accept:'application/json'}});
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            document.querySelectorAll('[data-myshie-cart-count]').forEach(el => {el.textContent=cart.item_count;el.hidden=cart.item_count===0;});
            if (window.MyshieCartDrawer) { status.hidden = true; window.MyshieCartDrawer.open(cart); }
          }
        } catch (error) { message.textContent = error.message || section.dataset.addError; status.hidden = false; }
        finally { form.removeAttribute('aria-busy'); buttons.forEach((button, i) => button.disabled = original[i]); }
      }));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(document)); else setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
